import { PageController } from '@client/components/_core/layout/PageController';
import { StringListSetting } from '@client/components/_core/settings/StringListSetting';
import { Space } from '@client/components/_ui/layout/Space';
import { useOrg } from '@client/hooks/business/org/useOrg';
import { incidentRisksSetting } from '@shared/schemas/org-settings';
import { createFileRoute } from '@tanstack/react-router';
import { Settings2, TriangleAlert } from 'lucide-react';
import { IdentificationMethods } from '../IdentificationMethods';
import { IncidentTypes } from '../IncidentTypes';
import { ProductsImpacted } from '../ProductsImpacted';

export const Route = createFileRoute('/console/$orgId/configuration/compliance/incidents/general/incident-details')({
    staticData: {
        metadata: {
            title: 'Incident details',
        },
        ui: {
            icon: Settings2,
            title: 'Incident settings',
            subtitle: 'Types, causes, impacts, timeline and lodgement form configuration',
        },
    },
    component: IncidentDetailsOptions,
});

function IncidentDetailsOptions() {
    const { enabledModules } = useOrg();
    const isRiskFeatureEnabled = enabledModules.includes('risk');

    return (
        <PageController route={Route}>
            <Space orientation="vertical" size="middle" className="w-full">
                <IncidentTypes />
                <div className="grid grid-cols-1 items-start gap-4 lg:grid-cols-2">
                    <IdentificationMethods />
                    <ProductsImpacted />
                    {!isRiskFeatureEnabled && (
                        <StringListSetting
                            definition={incidentRisksSetting}
                            icon={TriangleAlert}
                            title="Risks"
                            noun="risk"
                            description="The risks an incident can be linked to. With the risk module on, incidents link to the risk register instead."
                        />
                    )}
                </div>
            </Space>
        </PageController>
    );
}
